const userEditFormConfig = {
  underBtn: {
    title: 'Continue',
    show: false,
  },
  formWidth: '23vw',
  formItems: [
    {
      type: 'name',
      changeformItemBoxStyle: true,
      comeFormUserInfo: 'UserInfo',
      children: [
        {
          field: 'fname',
          label: 'fname',
          subLabel: 'nameSub',
          errorMsg: '',
          errorShow: false,
          disabled: true,
          on: false,
          comeForm: 'UserInfo',
        },
        {
          field: 'lname',
          label: 'lname',
          subLabel: 'nameSub',
          errorMsg: '',
          errorShow: false,
          disabled: true,
          on: false,
          comeForm: 'UserInfo',
        },
      ],
    },
    {
      field: 'email',
      leixing: 'userInfo',
      type: 'text',
      label: 'email',
      maxlength: '50',
      errorMsg: '',
      errorShow: false,
      disabled: true,
      changeformItemBoxStyle: true,
      on: false,
      comeFormUserInfo: 'UserInfo',
    },
    {
      field: 'mobileNumber',
      type: 'phone',
      label: 'mobileNumber',
      areaCodeTitle: 'areaCodeTitle',
      maxlength: '15',
      errorMsg: '',
      errorShow: false,
      changeformItemBoxStyle: true,
      on: false,
      comeForm: 'UserInfo',
    },
  ],
};

const dialogConfig = {
  mobileMaskAndModal: {
    position: 'initial',
    transform: 'initial',
  },
};

export { userEditFormConfig, dialogConfig };
